import { render, staticRenderFns } from "./NowRowItem.vue?vue&type=template&id=25d8ba20&"
import script from "./NowRowItem.vue?vue&type=script&lang=js&"
export * from "./NowRowItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports